

















import { Vue, Component } from 'vue-property-decorator'
import { TitleBlockModel } from '../models'
import TitleBlock from '../components/TitleBlock.vue'
import ItemsTick from '../components/ItemsTick.vue'

@Component({
  components: {
    TitleBlock,
    ItemsTick
  }
})

export default class BlockCapabilities extends Vue {
  hash: string = 'instructions'
  titles: TitleBlockModel = {
    title: 'Возможности',
    subtitle: 'Ведите свою деятельность официально&nbsp;&ndash; без отчётности, онлайн&#8209;кассы, бухгалтера или посещения налоговой'
  }
  percents = [
    { value: '4%', descr: 'с доходов от физлиц' },
    { value: '6%', descr: 'с доходов от юрлиц и ИП' }
  ]
  ticks = [ 'Нет других обязательных платежей', 'Нет отчетности и бухгалтерии', 'Налоговый вычет 10 000 ₽', 'Ставка до 2029 года' ]

  get breakpoint() { return this.$store.state.breakpoint }
  get isLtMd() { return this.breakpoint === 'xs' || this.breakpoint === 'sm' }
  get isXs() { return this.breakpoint === 'xs' }

  onBtnClick() {
    if (this.$route.hash.slice(1) === this.hash) {
      this.$router.push({path: '/'}, () => this.$router.push({path: `/#${this.hash}`}))
    } else this.$router.push({path: `/#${this.hash}`})
  }
}
